import Agreement from 'features/myVaro/screens/Legal/Agreement/Agreement';
import React from 'react';

export default function AgreementPage() {
  return <Agreement />;
}
